import { render, staticRenderFns } from "./VisitCalendar.vue?vue&type=template&id=515fe83a&scoped=true"
import script from "./VisitCalendar.vue?vue&type=script&lang=js"
export * from "./VisitCalendar.vue?vue&type=script&lang=js"
import style0 from "./VisitCalendar.vue?vue&type=style&index=0&id=515fe83a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fe83a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515fe83a')) {
      api.createRecord('515fe83a', component.options)
    } else {
      api.reload('515fe83a', component.options)
    }
    module.hot.accept("./VisitCalendar.vue?vue&type=template&id=515fe83a&scoped=true", function () {
      api.rerender('515fe83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visit-registration-calendar/components/VisitCalendar.vue"
export default component.exports